import { gql } from 'apollo-angular';

export const GET_CAMPAIGNS_LIST = gql`
  query ($criteria: SearchCampaignsCriteria!) {
    campaigns(criteria: $criteria) {
      id
      workflowId
      createdAt
      status
      customerCaseCount
      customerCaseIds
      filters {
        tenantId
        collectorIds
        workflowIds
        nodeId
        segmentId
        statuses
        minPendingAmount
        maxPendingAmount
        customerExternalIds
        operationExternalIds
      }
    }
  }
`;

export const GET_COLLECTOR = gql`
  query ($id: ID!) {
    collector(id: $id) {
      id
      tenantId
      name
      alias
      taxEntityId
      brandId
      serviceIds
      channelConfigIds
      paymentGatewayIds
      eventHookConfigIds
      feedbackOptionIds
      regionalConfigId
      managementFeeConfig
      currency
    }
  }
`;

export const UPDATE_NODE_PARAMETERS = gql`
  mutation ($input: UpdateNodeParametersInput!, $workflowInput: UpdateWorkflowInput!) {
    updateNodeParameters(input: $input, workflowInput: $workflowInput) {
      id
      name
      status
      silenced
      includedSegmentIds
      alias
      bucket {
        start
        finish
      }
      triggers
      nodes {
        nodeId
        type
        position
        parameters
        diagram {
          coordinates {
            x
            y
          }
        }
        childrenIds
      }
    }
  }
`;

export const UPDATE_WORKFLOW_COLLECTOR_IDS = gql`
  mutation ($input: UpdateWorkflowCollectorIdsInput!) {
    updateWorkflowCollectorIds(input: $input) {
      id
      collectorIds
    }
  }
`;
